import { useEffect, useState } from 'react'
import { User } from 'oidc-client-ts'
import { userManager } from './userManager'

export function useOidcAuth() {
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  const isAuthenticated = !!user && !user.expired

  useEffect(() => {
    let mounted = true
    setIsLoading(true)

    userManager.getUser().then((loadedUser) => {
      if (mounted) {
        setUser(loadedUser)
        setIsLoading(false)
      }
    })

    const userLoaded = (loadedUser: User) => {
      setUser(loadedUser)
    }

    const userUnloaded = () => {
      setUser(null)
    }

    userManager.events.addUserLoaded(userLoaded)
    userManager.events.addUserUnloaded(userUnloaded)

    return () => {
      mounted = false
      userManager.events.removeUserLoaded(userLoaded)
      userManager.events.removeUserUnloaded(userUnloaded)
    }
  }, [])

  const signinRedirect = () =>  userManager.signinRedirect()
  const signoutRedirect = () => userManager.signoutRedirect()
  

  return {
    isLoading,
    isAuthenticated,
    user,
    signinRedirect,
    signoutRedirect,
  }
}
